module.exports = __webpack_public_path__ + "static/media/postulante_background.344fb6fe.png";